import { InjectionToken, Type } from '@angular/core';

export const FUSE_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('FUSE_MOCK_API_DEFAULT_DELAY');

export const FUSE_MOCK_API_SERVICES = new InjectionToken<Type<unknown>[]>('FUSE_MOCK_API_SERVICES');
